export const getBidDisplayUnit = (unit: string) => {
  return unit === 'WATTS' ? 'MW' : 'MWh'
}
